export * from "./audio";
export * from "./camera";
export * from "./core";
export * from "./math";
export * from "./transition";

import * as math from "./math";
import * as utils from "./utils";

export {
    math,
    utils
}

global.P3 = exports;